export default {
  templateInfoText: `
  <div>
    <h5>{{marker.infoText.data.description}}</h5>
    <hr>
    <h6>Position Last Update</h6>
    <p><strong>{{moment.utc(marker.infoText.data.last_position_updated_at).tz($tz).format('L LT')}}</strong></p>
    <hr>
  </div>
  `,
  icon: {
    type: 'bullseye',
    size: [27, 36],
    anchor: [18, 39],
    text: '',
    colorByMinAge: [
      {
        days: 0,
        color: '#00dd00'
      },
      {
        days: 2,
        color: '#ffdd00'
      },
      {
        days: 4,
        color: '#dd0000'
      }
    ]
  }
}
